<template>
  <div class="check-detail">
    <div id="printArea" :style="{ width: printWidth + 'mm' }">
      <h2 class="title">新能源营运车辆日常安全检查单</h2>

      <div class="info-table">
        <table>
          <tr>
            <td width="15%">车牌号</td>
            <td width="20%">{{ mainBill.vehicleNo }}</td>
            <td width="24%">车型品牌</td>
            <td width="20%">{{ mainBill.brand }}</td>
            <td width="10%">车辆颜色</td>
            <td width="15%">{{ mainBill.color }}</td>
          </tr>
          <tr>
            <td>驾驶司机</td>
            <td>{{ mainBill.driverName }}</td>
            <td>司机是否确认</td>
            <td>是</td>
            <td>检查日期</td>
            <td>{{ (mainBill.arriveDate || mainBill.billDate) | dateFormat("yyyy-MM-dd") }}</td>
          </tr>
          <tr>
            <td>检查项目</td>
            <td colspan="5" class="content-cell">检查结果</td>
          </tr>

          <tr>
            <td rowspan="5">轮胎</td>
            <td>全车轮胎气压</td>
            <td colspan="4">
              <check-box :value="detail.tireQyLf" />
            </td>
          </tr>
          <tr>
            <td>右后轮胎老化</td>
            <td>
              <check-box :value="detail.tireLhRb" />
            </td>
            <td>右后轮胎破损</td>
            <td colspan="2">
              <check-box :value="detail.tireBsRf" />
            </td>
          </tr>
          <tr>
            <td>左后轮胎老化</td>
            <td>
              <check-box :value="detail.tireLhLb" />
            </td>
            <td>左后轮胎破损</td>
            <td colspan="2">
              <check-box :value="detail.tireBsLf" />
            </td>
          </tr>
          <tr>
            <td>右前轮胎老化</td>
            <td>
              <check-box :value="detail.tireLhRf" />
            </td>
            <td>右前轮胎破损</td>
            <td colspan="2">
              <check-box :value="detail.tireBsRf" />
            </td>
          </tr>
          <tr>
            <td>左前轮胎老化</td>
            <td>
              <check-box :value="detail.tireLhLf" />
            </td>
            <td>左前轮胎破损</td>
            <td colspan="2">
              <check-box :value="detail.tireBsLf" />
            </td>
          </tr>

          <tr>
            <td rowspan="4">刹车片</td>
            <td>右后刹车片</td>
            <td colspan="4">
              <check-box :value="detail.brakeRb" />
            </td>
          </tr>
          <tr>
            <td>左后刹车片</td>
            <td colspan="4">
              <check-box :value="detail.brakeLb" />
            </td>
          </tr>
          <tr>
            <td>右前刹车片</td>
            <td colspan="4">
              <check-box :value="detail.brakeRf" />
            </td>
          </tr>
          <tr>
            <td>左前刹车片</td>
            <td colspan="4">
              <check-box :value="detail.brakeLf" />
            </td>
          </tr>
          <tr>
            <td rowspan="3">底盘</td>
            <td>悬挂</td>
            <td colspan="4">
              <check-box :value="detail.dpXuanGa" />
            </td>
          </tr>
          <tr>
            <td>球头</td>
            <td colspan="4">
              <check-box :value="detail.dpBall" />
            </td>
          </tr>
          <tr>
            <td>支臂</td>
            <td colspan="4">
              <check-box :value="detail.dpArm" />
            </td>
          </tr>
          <tr>
            <td rowspan="3">油液</td>
            <td>刹车油</td>
            <td colspan="4">
              <check-box :value="detail.brakeOil" />
            </td>
          </tr>
          <tr>
            <td>防冻液</td>
            <td colspan="4">
              <check-box :value="detail.fdWater" />
            </td>
          </tr>
          <tr>
            <td>变速箱油</td>
            <td colspan="4">
              <check-box :value="detail.bsxOil" />
            </td>
          </tr>
          <tr>
            <td rowspan="4">灯光</td>
            <td>近光灯</td>
            <td colspan="4">
              <check-box :value="detail.nearLight" />
            </td>
          </tr>
          <tr>
            <td>远光灯</td>
            <td colspan="4">
              <check-box :value="detail.remoteLight" />
            </td>
          </tr>
          <tr>
            <td>转向灯</td>
            <td colspan="4">
              <check-box :value="detail.turnLight" />
            </td>
          </tr>
          <tr>
            <td>刹车灯</td>
            <td colspan="4">
              <check-box :value="detail.brakeLight" />
            </td>
          </tr>
          <tr>
            <td rowspan="3">随车件</td>
            <td>车载灭火器</td>
            <td colspan="4">
              <check-box value="1" normal-text="有" abnormal-text="无" />
            </td>
          </tr>
          <tr>
            <td>三角警示牌</td>
            <td colspan="4">
              <check-box value="1" normal-text="有" abnormal-text="无" />
            </td>
          </tr>
          <tr>
            <td>三角木</td>
            <td colspan="4">
              <check-box value="1" normal-text="有" abnormal-text="无" />
            </td>
          </tr>
          <tr>
            <td rowspan="3">其他</td>
            <td>雨刷</td>
            <td colspan="4">
              <check-box :value="detail.rainbrush" />
            </td>
          </tr>
          <tr>
            <td>小电瓶</td>
            <td colspan="4">
              <check-box :value="detail.xdpBattery" />
            </td>
          </tr>
          <tr>
            <td>高压电池</td>
            <td colspan="4">
              <check-box :value="detail.battery" />
            </td>
          </tr>
          <tr>
            <td>车辆照片</td>
            <td colspan="5" class="content-cell photo-cell">
              <div class="photo-area">
                <div class="photo-list">
                  <div v-for="(img, index) in checkImgs" :key="index" class="photo-item">
                    <img :src="img" alt="车辆照片" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>检查备注</td>
            <td colspan="5" class="content-cell">{{ checkRemark }}</td>
          </tr>
          <tr>
            <td>检查单位</td>
            <td>{{ mainBill.providerName }}</td>
            <td>当前里程数</td>
            <td>{{ detail.totalMiles }} 公里</td>
            <td>检查人员</td>
            <td>{{ mainBill.staffName }}</td>
          </tr>
          <tr>
            <td>检查人员签名</td>
            <td colspan="5" class="content-cell">
              <img :src="mainBill.staffSign" width="60px" height="auto" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from "@/components/PrintCheckBox";

export default {
  name: "CheckDetailLegacy",
  components: {
    CheckBox
  },
  props: {
    printWidth: {
      type: Number,
      default: 210
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    data: {
      handler(newVal) {
        const { mainBill, detail, items } = newVal;
        this.detail = detail;
        this.mainBill = mainBill;
        this.items = items;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    checkImgs() {
      const items = this.items || [];
      const imgs = [];
      items.forEach((item) => {
        if (item.photoes) {
          imgs.push(...item.photoes);
        }
      });
      return imgs.slice(0, 2);
    },
    checkRemark() {
      const items = this.items || [];
      return items
        .filter((item) => item.desc)
        .map((item) => item.desc)
        .join("、");
    }
  },
  data() {
    return {
      detail: {},
      mainBill: {},
      items: []
    };
  }
};
</script>

<style lang="less" scoped>
.check-detail {
  padding: 20px;

  #printArea {
    margin: 0 auto;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;

    .title {
      text-align: center;
      margin-bottom: 20px;
      font-size: 20px;
    }

    .info-table {
      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;

        td {
          border: 1px solid #000;
          padding: 8px;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
        }

        .content-cell {
          min-height: 60px;
          vertical-align: top;
        }

        .photo-cell {
          min-height: 120px;

          .photo-area {
            min-height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px dashed #ccc;
            margin-bottom: 10px;

            .photo-list {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
              justify-content: center;

              .photo-item {
                flex: 1 1 45%;
                display: flex;
                justify-content: center;
                align-items: center;
                min-width: 0;

                img {
                  width: 100%;
                  max-width: 180px;
                  max-height: 220px;
                  object-fit: cover;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }

  @media print {
    padding: 0;
    background: #fff;

    #printArea {
      padding: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    table,
    td {
      word-break: break-word;
      overflow-wrap: anywhere;
    }
  }

  .check-box {
    font-family: "Segoe UI Symbol", sans-serif;
    margin: 0 4px;
    font-size: 16px;
  }
}
</style>
